import type { ElementType } from 'react';

import ManageSearch from '@mui/icons-material/ManageSearch';
import { Link as RouterLink } from 'react-router';

import Crown from '@/assets/icons/Crown';
import { useUserDetails } from '@/features/_shared/user';
import { normalizeSx } from '@/shared/lib/normalizeSx';
import type { ButtonProps, ButtonSize } from '@/shared/ui/primitives/Button';
import Button from '@/shared/ui/primitives/Button';
import { useAppDispatch } from '@/store/hooks';
import { closeDrawer } from '@/store/slices/drawer.slice';

import type { Sx } from '@/shared/types/uiTypes';

type ButtonType = 'expired' | 'manage' | 'upgrade';

const BUTTON_CONFIG: Record<ButtonType, { icon: ElementType; label: string }> = {
  expired: { icon: Crown, label: 'Upgrade plan' },
  manage: { icon: ManageSearch, label: 'Manage subscription' },
  upgrade: { icon: Crown, label: 'Upgrade plan' }
};

const baseSx: Sx = {
  minWidth: 250,
  outline: 'none',
  boxShadow: 'none',
  border: 'none',
  fontSize: 14
};

const UpgradeToPremiumButton = ({
  sx,
  type,
  size,
  color
}: {
  sx?: Sx;
  type: ButtonType;
  size?: ButtonSize;
  color?: ButtonProps['color'];
}) => {
  const { isUserExpired } = useUserDetails();
  const dispatch = useAppDispatch();

  const effectiveType = isUserExpired ? 'expired' : type;
  const { icon: Icon, label } = BUTTON_CONFIG[effectiveType];

  return (
    <Button
      color={color}
      component={RouterLink}
      size={size}
      startIcon={<Icon />}
      sx={[baseSx, ...normalizeSx(sx)]}
      to='/manage-subscription'
      variant='contained'
      onClick={() => {
        dispatch(closeDrawer());
      }}
    >
      {label}
    </Button>
  );
};

export default UpgradeToPremiumButton;
